(function($){

	function renderElement(element){
		$(element).addClass('active');
		$(element).removeClass('d-none');
	}
	function destroyElement(element) {
		$(element).removeClass('active');
		$(element).addClass('d-none');
	}
	function renderLightbox(){
		var lightboxRender = '';
		lightboxRender += '<div id="lightbox-overlay" class=""></div>';
		lightboxRender += '<div id="lightbox-content" class="">';
		lightboxRender += '<div class="close-btn">CLOSE</div>';
		lightboxRender += '<div class="lightbox-container">';
		lightboxRender += '<div class="inner-container">';
		lightboxRender += '<div class="gallery-swiper" id="gallery-swiper">';
		lightboxRender += '<div class="swiper-wrapper"></div>';
		lightboxRender += '<div class="swiper-button-prev"></div>';
		lightboxRender += '<div class="swiper-button-next"></div>';
		lightboxRender += '</div></div></div></div>';
		$('body').append(lightboxRender);
	}
	function renderGallery(clickedImage, imageGroup) {
		$('#gallery-swiper .swiper-wrapper').empty();

		var gallerySwiper = new Swiper('.gallery-swiper', {
			// el: '.gallery-swiper',
			spaceBetween: 0,
			slidesPerView: 1,
			grabCursor: true,
			keyboard: {
				enabled: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			observeParents: true,
			observer: true
		});

		var lightboxGroup = imageGroup;
		var images = [];

		$('a[data-sslightbox="'+lightboxGroup+'"]').each(function(){
			var thisImage = $(this).attr('href');
			images.push(thisImage);
		});

		var selectedImage = $.inArray(clickedImage, images);

		$(images).each(function(){
			var thisImage = '<div class="swiper-slide"><div class="image-mask" style="background-image: url(' + this + ');"></div></div>';
			gallerySwiper.appendSlide(thisImage);
			gallerySwiper.update();
		});

		gallerySwiper.update();
		gallerySwiper.slideTo(selectedImage, 0, false);
	}

	$(function(){
		var galleryInit = $('a[data-sslightbox]');
		if (galleryInit.length){
			renderLightbox();
		}
		$('a[data-sslightbox]').click(function(e){
			e.preventDefault();
			renderElement("#lightbox-overlay");
			renderElement("#lightbox-content");

			var lightboxGroup = $(this).data('sslightbox');
			var clickedImage = $(this).attr('href');
			renderGallery(clickedImage, lightboxGroup);
		});

		$('body').on('click', '#lightbox-content .close-btn', function(){
			destroyElement('#lightbox-content');
			destroyElement('#lightbox-overlay');
		})
	})

}(jQuery))